import { put, select, takeLatest } from "redux-saga/effects";
import * as Action from "../actions/Actions";
import { getKeyWordsData } from "../selectors/Selectors";
import { DISPATCHES } from "../../InterfacesTypes/enums";
import type { IKeyWords } from "InterfacesTypes/interfaces";
import type { PayloadAction } from "@reduxjs/toolkit";

function* searchKeyWords(action?: PayloadAction<string>) {
  if (!action) return;
  yield put(Action.searchInputAction(action.payload));
  const keyWordsData: IKeyWords[] = yield select(getKeyWordsData);

  let searchResult: IKeyWords[] = Array(0);

  if (action.payload.length >= 2) {
    // returns search results based on keywords
    const tempSearchString = action.payload;

    searchResult = keyWordsData.filter((item) => {
      return (
        item.KeyWords &&
        tempSearchString &&
        item.KeyWords.toLowerCase().includes(tempSearchString.toLowerCase())
      );
    });

    yield put(Action.searchResultDispatchAction(searchResult));

    const matchingKeyWordStrings: string[] = [];
    for (const item of searchResult) {
      if (
        item.KeyWords.toLowerCase().includes(tempSearchString.toLowerCase())
      ) {
        matchingKeyWordStrings.push(item.KeyWords);
      }
    }

    yield put(Action.setMatchingKeyWordStrings(matchingKeyWordStrings));
    const matchingIndividualKeyWordsArray: string[] = [];

    matchingKeyWordStrings.forEach((str: string) => {
      const words: string[] = str.split(";");
      words.forEach((word: string) => {
        // IF word does not exist in matchingIndividualKeyWordsArry adds word
        // used to remove duplicates
        if (
          matchingIndividualKeyWordsArray.indexOf(word.toUpperCase()) === -1
        ) {
          matchingIndividualKeyWordsArray.push(word.toUpperCase());
        }
      });
    });

    yield put(Action.setMatchingKeyWordsArray(matchingIndividualKeyWordsArray));
  }
}

export function* searchKeyWordsSaga() {
  yield takeLatest(DISPATCHES.SEARCH_KEYWORD_SAGA, searchKeyWords);
}
